import Default from './default';

import Slider from '../components/slider';
import ContentTab from '../components/contentTab';

class Standard extends Default {
	namespace = 'standard';

	beforeEnter = data => {
		super.beforeEnter(data);
		const scope = data.next.container;
		this.initSlider(scope);
		this.initContentTab(scope);
	};

	afterLeave = data => {
		super.afterLeave(data);
	};

	afterEnter = data => {
		super.afterEnter(data);
	};

	initSlider = scope => {
		const $sliders = $(scope).find('[data-slider="el"]');

		if ($sliders.length) {
			$sliders.each((i, el) => {
				console.log('init slider');
				new Slider($(el));
			});
		}
	};

	initContentTab = () => {
		const $contentTabs = $('[data-contenttab="el"]');
		if ($contentTabs.length) {
			$contentTabs.each((i, el) => {
				new ContentTab($(el));
			});
		}
	};
}

export default new Standard();
